export default function PageTitle({ title }: { title: string }) {
  return (
    <>
      <div className="w-full absolute left-0">
        <h1 className="bg-[#f2f1f6] p-8 pt-12 text-center font-domine text-3xl font-bold">
          {title}
        </h1>
        <div className="h-[40px] bg-[url('/paper.svg')] bg-[bottom] bg-[length:50%_40px] [transform:rotateX(180deg)]"></div>
      </div>
    </>
  );
}
